// extracted by mini-css-extract-plugin
module.exports = {"root":"Loading_root__xdbKn","shimmer":"Loading_shimmer__SY_nH"};